import React, { FunctionComponent } from 'react';
import { FullScreenHeader } from 'components/Layouts/FullScreenView/FullScreenHeader';

export const RecordingEmbedHeader: FunctionComponent = () => {
  return <FullScreenHeader />;
};
